import qs from 'qs'
import { FIND_LOWER_PRICE_MODAL_PAGE_SRC } from './constants'

export const getFindLowerPriceModalUrl = skuId => `${FIND_LOWER_PRICE_MODAL_PAGE_SRC}?${qs.stringify({ skuId })}`
